export const convertCurrency = (amount,Taux) => {

    
    if((50<=amount) && (amount<=100))
    {
        return (amount*(Taux+ 60) ).toFixed(2)
    } 
    if((100<amount) && (amount<=300))
    {
        return(amount*(Taux+ 68)).toFixed(2)
    }
    if((300<amount) && (amount<=500))
    {
        return(amount*(Taux+72)).toFixed(2)
    }
    if((500<amount) && (amount<=800))
    {
        return(amount*(Taux+76)).toFixed(2)
    }
    if((800<amount) && (amount<=1500))
    {
        return(amount*(Taux+80)).toFixed(2)
        
    }
    if((1500<amount) && (amount<=5000))
    {
        return(amount*(Taux+84)).toFixed(2)
    }

}


// minimum 50 and max 5000
